import React, { useState, useEffect } from "react";
import { GitHubCalendar } from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  const [blockSize, setBlockSize] = useState(15);
  const [blockMargin, setBlockMargin] = useState(5);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 500) {
        setBlockSize(10); // smaller blocks for mobile
        setBlockMargin(2);
      } else if (window.innerWidth < 768) {
        setBlockSize(12); // medium blocks for tablets
        setBlockMargin(4);
      } else {
        setBlockSize(15); // normal blocks for desktop
        setBlockMargin(5);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const purpleTheme = {
    light: ["#ebedf0", "#c084f5", "#a65be2", "#933dd4", "#771dbe"],
    dark: ["#161b22", "#5c3382", "#7b41b3", "#9d5be3", "#c084f5"],
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        Days I <strong className="purple">Code</strong>
      </h1>
      <div className="github-calendar-wrapper" style={{ width: "100%", overflow: "hidden" }}>
        <GitHubCalendar
          username="Spidycoder-AS"
          blockSize={blockSize}
          blockMargin={blockMargin}
          theme={purpleTheme}
          fontSize={16}
          year={new Date().getFullYear()}
        />
      </div>
    </Row>
  );
}

export default Github;
